import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import {
  StripeError,
  StripePaymentElementChangeEvent,
} from '@stripe/stripe-js';
import { useRouter } from 'next/router';
import { ForwardedRef, forwardRef, useImperativeHandle } from 'react';

export interface IOrderStripeCreditCardPaymentElementProps {
  ordersIds: number[];
  handleOnReady: () => void;
  handleOnChange: (event: StripePaymentElementChangeEvent) => void;
  handleOnBlur: (event: any) => void;
  handleOnError: (error: StripeError) => void;
}
const OrderStripeCreditCardPaymentElement = forwardRef(
  (
    props: IOrderStripeCreditCardPaymentElementProps,
    ref: ForwardedRef<any>
  ) => {
    const stripe = useStripe();
    const elements = useElements();
    const router = useRouter();

    const handleSubmit = async () => {
      if (!stripe || !elements) {
        return;
      }

      const ordersIdsParam = encodeURIComponent(
        JSON.stringify(props.ordersIds)
      );
      const redirectUrlBase = window.origin;
      const redirectUrlLocalePath =
        router.locale !== 'en' ? `/${router.locale}` : '';
      const redirectUrlPath = '/credit-card-checkout-result';
      const redirectUrlQuery = `?ordersIds=${ordersIdsParam}`;
      const redirectUrl = `${redirectUrlBase}${redirectUrlLocalePath}${redirectUrlPath}${redirectUrlQuery}`;
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: redirectUrl,
        },
      });

      if (result.error) {
        props.handleOnError(result.error);
        return null;
      } else {
        return result;
      }
    };

    useImperativeHandle(ref, () => ({
      async pay() {
        return await handleSubmit();
      },
    }));

    return (
      <form>
        <PaymentElement
          onReady={props.handleOnReady}
          onChange={props.handleOnChange}
          onBlur={props.handleOnBlur}
        />
      </form>
    );
  }
);

OrderStripeCreditCardPaymentElement.displayName = 'OrderStripeElements';
export default OrderStripeCreditCardPaymentElement;
